import requestWrapper from '../shared/lib/requestWrapper';
import constants from '../shared/constants';

async function create(payload) {
    var response = await requestWrapper({
        url:    '/AppointmentOtherInfos',
        method: 'POST',
        data: payload.data,
        baseURL: constants.sdn.baseUrl,
        notifications: payload.notifications
    });

    return response;
}

async function update(payload) {
    var response = await requestWrapper({
        url:    '/AppointmentOtherInfos/' + payload.data.id,
        method: 'PUT',
        data: payload.data,
        baseURL: constants.sdn.baseUrl,
        notifications: payload.notifications
    });

    return response;
}

async function get(payload) {
    var response = await requestWrapper({
        url:    '/AppointmentOtherInfos/appointment/' + payload.data.idAppointment,
        method: 'GET',
        baseURL: constants.sdn.baseUrl,
        notifications: payload.notifications
    });

    return response;
}

const AppointmentOtherInfosService = {
    create, update, get
}

export default AppointmentOtherInfosService;